import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    IconButton,
    Icon,
    useColorMode
} from "@chakra-ui/react";
import { MdMoreVert, MdFileCopy, MdDelete } from "react-icons/md";
const ActionMenu = ({ onDuplicate, onDelete }) => {
    const { colorMode } = useColorMode();
    return (
        <Menu>
            <MenuButton
                as={IconButton}
                icon={<MdMoreVert />}
                variant="ghost"
                size="md"
                aria-label="More options"
            />
            <MenuList>
                <MenuItem
                    onClick={onDuplicate}
                    sx={{
                        '& .menu-icon': {
                            transition: 'color 0.2s',
                        },
                        _hover: {
                            color: colorMode === 'light'?'black':'white', // text color on hover
                            '& .menu-icon': {
                                color: 'brand.500', // icon color on hover
                            },
                        },
                    }}
                >
                    <Icon as={MdFileCopy} mr={2} className="menu-icon" />
                    Duplicate
                </MenuItem>

                <MenuItem
                    onClick={onDelete}
                    sx={{
                        '& .menu-icon': {
                            transition: 'color 0.2s',
                        },
                        _hover: {
                            color: colorMode === 'light'?'black':'white', // text color on hover
                            '& .menu-icon': {
                                color: 'red.500', // icon becomes red
                            },
                        },
                    }}
                >
                    <Icon as={MdDelete} mr={2} className="menu-icon" />
                    Delete
                </MenuItem>
            </MenuList>
        </Menu>
    );
}

export default ActionMenu;